import orderBy from "lodash.orderby";

import { ExperienceActionDto } from "@intelligems/ig-types";

export const actionTsDescSort = (
  a: ExperienceActionDto,
  b: ExperienceActionDto
): number => {
  if (a.actionTs < b.actionTs) {
    return 1;
  }
  if (a.actionTs > b.actionTs) {
    return -1;
  }
  return 0;
};

export const actionTsAscSort = (
  a: ExperienceActionDto,
  b: ExperienceActionDto
): number => {
  if (a.actionTs > b.actionTs) {
    return 1;
  }
  if (a.actionTs < b.actionTs) {
    return -1;
  }
  return 0;
};

export const getStartedAtTs = (experienceActions: ExperienceActionDto[]) => {
  if (!experienceActions?.length) {
    return null;
  }

  const sortedActions = [...experienceActions].sort(actionTsDescSort);
  const foundIndex = sortedActions.findIndex(
    (action) => action.action === "start"
  );
  if (foundIndex > -1) {
    return sortedActions[foundIndex];
  } else return null;
};

export const getPausedAtTs = (experienceActions: ExperienceActionDto[]) => {
  if (!experienceActions?.length) {
    return null;
  }

  const sortedActions = [...experienceActions].sort(actionTsDescSort);

  if (sortedActions[0].action === "pause") {
    return sortedActions[0];
  }
  return null;
};

export const getEndedAtTs = (experienceActions: ExperienceActionDto[]) => {
  if (!experienceActions?.length) {
    return null;
  }

  const sortedActions = [...experienceActions].sort(actionTsDescSort);

  if (sortedActions[0].action === "end") {
    return sortedActions[0];
  }
  return null;
};

export const getFirstStartedAtTs = (
  experienceActions: ExperienceActionDto[]
) => {
  const sortedActions = orderBy(experienceActions, ["actionTs"], ["asc"]);
  const foundIndex = sortedActions.findIndex(
    (action) => action.action === "start"
  );
  if (foundIndex > -1) {
    return sortedActions[foundIndex].actionTs;
  } else return null;
};

export const getLastEndedAtTs = (experienceActions: ExperienceActionDto[]) => {
  const sortedActions = orderBy(experienceActions, ["actionTs"], ["asc"]);
  const foundIndex = sortedActions.findIndex(
    (action) => action.action === "end"
  );
  if (foundIndex > -1) {
    return sortedActions[foundIndex].actionTs;
  } else return null;
};
